import OperatorsBreadCrumbs from './OperatorsBreadCrumbs';

export default OperatorsBreadCrumbs;
